import React, { useEffect, useState } from "react";
import axios from "axios";
import ChartContainer from "./Components/ChartContainer";
import GlobalMarketsTable from "./Components/GlobalMarketsTable";
import FiiDiiChartComponent from "./Components/FiiDiiLineChart";
import ChartSkeleton from "./Components/ShimmerSkeleton";
import IndianMarketsTable from "./Components/IndianMarketsTable";

const GlobalMarket = () => {
  const [apiData, setApiData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  // Fetch data on component mount
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(
          "https://e5rm5v64eg.execute-api.ap-south-1.amazonaws.com/default/discoverData"
        );
        setApiData(response.data);
      } catch (error) {
        console.log("API response error:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="flex flex-col gap-8 max-w-8xl">
      {isLoading ? (
        <ChartSkeleton />
      ) : (
        <>
          <ChartContainer data={apiData} />
          <div className="grid grid-cols-2 gap-3">

          <GlobalMarketsTable data={apiData} />
          <IndianMarketsTable data={apiData} />
          </div>
          <FiiDiiChartComponent />
        </>
      )}
    </div>
  );
};

export default GlobalMarket;
